import { gql } from '@apollo/client';
import { PAYMENT_FIELDS } from '../../fragments';
import { AddPaymentProps, DeletePaymentProps, UpdatePaymentProps } from './payment.types';
import { PaymentType } from '../../../types';
import { GET_PAYMENTS_BY_REFERENCE_ID, GET_PAYMENT_BY_ID } from '../../queries';

export const ADD_PAYMENT = gql`
  ${PAYMENT_FIELDS}
  mutation AddPayment(
  $referenceId: ID!
  $note: String!
  $paymentInvoice: String!
  $paymentAmount: Float!
  $paymentMadeBy: String!
  $paymentReceivedBy: String!
  $date: String
  ) {
    addPayment(
    referenceId: $referenceId
    note: $note
    paymentInvoice: $paymentInvoice
    paymentAmount: $paymentAmount
    paymentMadeBy: $paymentMadeBy
    paymentReceivedBy: $paymentReceivedBy
    date: $date
    ) {
      ...PaymentFields
    }
  }
`;

export function addPayment({
  client,
  referenceId,
  note,
  paymentInvoice,
  paymentAmount,
  paymentMadeBy,
  paymentReceivedBy,
  date,
}: AddPaymentProps) {
  return client?.mutate<{ addPayment: PaymentType }>({
    mutation: ADD_PAYMENT,
    variables: {
      referenceId,
      note,
      paymentInvoice,
      paymentAmount,
      paymentMadeBy,
      paymentReceivedBy,
      date,
    },
    refetchQueries: [
      GET_PAYMENTS_BY_REFERENCE_ID,
    ],
  });
}

export const UPDATE_PAYMENT = gql`
  ${PAYMENT_FIELDS}
  mutation UpdatePayment(
  $paymentId: ID!
  $paymentAmount: Float
  $date: String
  $paymentInvoice: String
  $paymentMadeBy: String
  $paymentReceivedBy: String
  ) {
    updatePayment(
    paymentId: $paymentId
    paymentAmount: $paymentAmount
    date: $date
    paymentInvoice: $paymentInvoice
    paymentMadeBy: $paymentMadeBy
    paymentReceivedBy: $paymentReceivedBy
    ) {
      ...PaymentFields
    }
  }
`;

export function updatePayment({
  client,
  paymentId,
  paymentAmount,
  date,
  paymentInvoice,
  paymentMadeBy,
  paymentReceivedBy,
}: UpdatePaymentProps) {
  return client?.mutate<{ addPayment: PaymentType }>({
    mutation: UPDATE_PAYMENT,
    variables: {
      paymentId,
      paymentAmount,
      date,
      paymentInvoice,
      paymentMadeBy,
      paymentReceivedBy,
    },
    refetchQueries: [
      GET_PAYMENT_BY_ID,
      GET_PAYMENTS_BY_REFERENCE_ID,
    ],
  });
}

export const REMOVE_PAYMENT = gql`
  mutation RemovePayment($paymentId: ID!) {
    removePayment(paymentId: $paymentId)
  }
`;

export function deletePayment({
  client,
  paymentId,
}: DeletePaymentProps) {
  return client?.mutate<{ addPayment: PaymentType }>({
    mutation: REMOVE_PAYMENT,
    variables: {
      paymentId,
    },
    refetchQueries: [
      GET_PAYMENT_BY_ID,
      GET_PAYMENTS_BY_REFERENCE_ID,
    ],
  });
}
